"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPrimeDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var isPrimeDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsPrime: _factoriesAny.createIsPrime
};
exports.isPrimeDependencies = isPrimeDependencies;